import { createStore } from 'vuex';
import baseModules from './modules';
import auth from './modules/auth';

const combinedModules = {
  ...baseModules,
  auth,
};

const store = createStore({
  modules: combinedModules,
  state: {
    sessions: [],
  },
  mutations: {
    SET_SESSIONS(state, sessions) {
      state.sessions = sessions;
    },
  },
  actions: {
    saveSessions({ commit }, sessions) {
      commit('SET_SESSIONS', sessions);
    },
  },
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
